import React from 'react';
import { Link } from 'react-router-dom';
import useNavigation from '@hooks/useNavigation';
import useTranslationLgs from '@hooks/i18n/useTranslation';

interface ComponentProps {
  expeditionId: string;
  expeditionAppId?: string;
}

/**
 * Compact "Expedition" badge linking to an expedition detail.
 * Light-orange pill with a gray label and an orange linked application id.
 */
const ExpeditionBadge: React.FC<ComponentProps> = ({ expeditionId, expeditionAppId }) => {
  const { tr } = useTranslationLgs();
  const navigation = useNavigation();

  return (
    <div className="px-2 py-1 bg-[#ffeee5] rounded text-sm inline-flex flex-wrap w-fit mt-2">
      <span className="text-gray-600">{tr('SupplierNotificationList.expedition', 'Expedition')}</span>
      <Link to={navigation.createNavigationLink(navigation.urlFunctions.createExpeditionDetailV2(expeditionId))}>
        <span className="font-medium hover:text-orange-800 ml-1">{expeditionAppId}</span>
      </Link>
    </div>
  );
};

export default ExpeditionBadge;